import React from "react";
import { FaLeaf } from "react-icons/fa6";
import everything from "../assets/Everything.png";
import { motion } from "framer-motion";

const Locations = () => {
  const places = [
    "3 min Drive to Amaravathi IRR",
    "1.5 km from IRR",
    "500 meters from Ananthapur-Amaravathi Express Highway",
    "6 km to AP Secretariat Amaravathi",
    "2 km to Delhi Public School",
    "5 km to Agriculture Research Center",
    "10 min Drive to VIT University",
    "10 min Drive to SRM University",
    "0.5 km to Tadikonda Village",
    "10 min Drive to High Court",
  ];


  return (
    <div className="bg-[#dee3dd] flex flex-col items-center py-12 px-6">
      {/* Animated Heading */}
      <motion.h2
        className="text-4xl font-bold text-center mb-6"
        initial={{ y: 50, opacity: 50 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        Everything is Right Around the Corner
      </motion.h2>

      <div className="flex flex-col md:flex-row items-center max-w-5xl w-full gap-8">
        {/* YouTube Video Embed */}
        <div className="w-full md:w-1/2">
          <img
            className="w-full h-64 md:h-96 rounded-lg shadow-lg"
            src={everything}
            alt="Everything"
          />
        </div>

        {/* Locations List with animations */}
        <div className="w-full md:w-1/2">
          <ul className="text-lg space-y-3">
            {places.map((place, index) => (
              <motion.li
                key={index}
                className="flex items-center"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }} // stagger delay
              >
                <span className="text-[#38603D] mr-2">
                  <FaLeaf />{" "}
                </span>
                {place}
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Locations;
